import type { ReactNode, RefObject } from "react";
import {
  PickerList,
  type PickerListItem,
} from "@/features/sparxsEditor/components/molecules/pickerList/pickerList";

export type DirectiveSegmentPickerListProps = {
  items: PickerListItem[];
  selectedIndex: number;
  onSelect: (item: PickerListItem) => void;
  optionIdPrefix: string;

  className?: string;
  emptyMessage?: ReactNode;

  containerRef?: RefObject<HTMLDivElement | null>;
  firstItemRef?: RefObject<HTMLDivElement | null>;
  onHighlightChange?: (index: number) => void;

  onEscape?: () => void;

  filterValue?: string;
  onFilterChange?: (value: string) => void;
  filterInputRef?: RefObject<HTMLInputElement | null>;
  filterPlaceholder?: string;
  filterAriaLabel?: string;
};

export const DirectiveSegmentPickerList = ({
  items,
  selectedIndex,
  onSelect,
  optionIdPrefix,
  className,
  emptyMessage,
  containerRef,
  firstItemRef,
  onHighlightChange,
  onEscape,
  filterValue,
  onFilterChange,
  filterInputRef,
  filterPlaceholder,
  filterAriaLabel,
}: DirectiveSegmentPickerListProps): ReactNode => (
  <PickerList
    items={items}
    onSelect={onSelect}
    selectedIndex={selectedIndex}
    onHighlightChange={onHighlightChange}
    optionIdPrefix={optionIdPrefix}
    firstItemRef={firstItemRef}
    className={className ?? ""}
    emptyMessage={emptyMessage}
    containerRef={containerRef}
    onEscape={onEscape}
    filterValue={filterValue}
    onFilterChange={onFilterChange}
    filterInputRef={filterInputRef}
    filterPlaceholder={filterPlaceholder}
    filterAriaLabel={filterAriaLabel}
  />
);
